<template>
    <CRow>
        <CCol col="12">
            <CCard>
                <CCardHeader>
                    <strong>{{ partner.title }}: Создание скидочной карты</strong>
                </CCardHeader>
                <CCardBody>
                    <!-- <PartnerDiscountCardTabLinks /> -->
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <div v-if="groups.length > 0 && !groupCreating" class="form-row">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label"
                            >Группа</CCol
                            >
                            <CCol sm="9" class="col-form-label">
                                <CSelect
                                    inline
                                    :value.sync="discount_card.group_id"
                                    :options="groups"
                                    placeholder="Группа"
                                    @change="updateGroupId"
                                />
                                <CButton
                                    color="primary"
                                    class="mr-3"
                                    @click="groupCreating = true"
                                >Создать группу</CButton
                                >
                            </CCol>
                        </div>
                        <div v-if="groups.length === 0 || groupCreating" class="form-row">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label"
                            >Группа</CCol
                            >
                            <CCol sm="9" class="col-form-label">
                                <CInput
                                    v-model="discount_card.group_title"
                                    placeholder="Введите название группы"
                                />
                                <CButton
                                    v-if="groups.length > 0"
                                    color="primary"
                                    class="mr-3"
                                    @click="groupCreating = false"
                                >Назад</CButton
                                >
                            </CCol>
                        </div>
                        <CInput
                            v-model="discount_card.priority"
                            label="Приоритет"
                            horizontal
                            placeholder="Введите приоритет скидочной карты в рамках выбранной группы"
                        />

                        <CInput
                            v-model="discount_card.title"
                            label="Название"
                            horizontal
                            placeholder="Введите название скидочной карты"
                        />
                        <CInputFile
                            ref="picture"
                            label="Изображение"
                            horizontal
                            @change="selectPicture"
                        />
                        <CInputFile
                            ref="picture_bg"
                            label="Фон карточки (picture_bg)"
                            horizontal
                            @change="selectPictureBg"
                        />
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                С анимацией
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="discount_card.animated"
                                />
                            </CCol>
                        </CRow>
                        <CInputFile
                            ref="animation"
                            v-show="discount_card.animated"
                            label="Анимация"
                            horizontal
                            @change="selectAnimation"
                        />
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Показать на карте текущее время
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="discount_card.timed"
                                />
                            </CCol>
                        </CRow>
                        <CInput
                            v-model="discount_card.link"
                            label="Ссылка на карточку партнера"
                            horizontal
                            placeholder="Введите ссылку на карточку партнера"
                        />
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Активен
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="discount_card.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="create"
                    >Создать</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Отмена</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import PartnerDiscountCardTabLinks from '@/components/partner/PartnerDiscountCardTabLinks';

    export default {
        name: 'DiscountCardEdit',

        components: {
            PartnerDiscountCardTabLinks,
        },

        data() {
            return {
                partner: {},
                discount_card: {
                    group_id: null,
                    priority: 0,
                    partner_id: 0,
                    title: '',
                    picture: '',
                    picture_bg: '',
                    link: null,
                    enabled: true,
                },
                selectedPicture: null,
                selectedPictureBg: null,
                selectedAnimation: null,
                groups: [],
                groupCreating: false
            };
        },

        computed: {
        },

        mounted() {
            const id = parseInt(this.$route.params.id);
            Vue.axios
                .get('/partners/' + id)
                .then(resp => {
                    this.partner = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        
            Vue.axios
                .get('/discount-cards/' + id + '/groups')
                .then(resp => {
                    this.groups = resp.data.map(el => {
                        return {
                            label: el.title,
                            value: el.id
                        }
                    });
                    if(this.groups.length === 0) {
                        this.groupCreating = true;
                    }
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            selectPicture(FileList) {
                this.selectedPicture = FileList[0];
            },
            selectPictureBg(FileList) {
                this.selectedPictureBg = FileList[0];
            },
            selectAnimation(FileList) {
                this.selectedAnimation = FileList[0];
            },

            async create() {
                if (!this.groupCreating && !this.discount_card.group_id) {
                    this.$root.$emit('showError', 'Укажите группу скидочной карты.');
                    return;
                }
                if (this.groupCreating && !this.discount_card.group_title) {
                    this.$root.$emit('showError', 'Укажите название группы скидочной карты.');
                    return;
                }
                if (!this.discount_card.title) {
                    this.$root.$emit('showError', 'Укажите название скидочной карты.');
                    return;
                }
                if(!this.selectedPicture) { 
                    this.$root.$emit('showError', 'Загрузите изображение скидочной карты.');
                    return;
                }
                this.discount_card.partner_id = this.partner.id;
                this.discount_card.enabled = this.discount_card.enabled ? true : false;
                this.discount_card.animated = this.discount_card.animated ? true : false;
                this.discount_card.timed = this.discount_card.timed ? true : false;
                this.discount_card.priority = +this.discount_card.priority;
            
                if(this.groupCreating) {
                    this.discount_card.group_id = null;
                }

                // Загружаем картинку
                this.discount_card.picture = await this.uploadPicture(this.selectedPicture);
                if(this.selectedPictureBg) {
                    this.discount_card.picture_bg = await this.uploadPicture(this.selectedPictureBg);
                }
                if(this.selectedAnimation) {
                    this.discount_card.animation = await this.uploadPicture(this.selectedAnimation);
                }

                await this.axios.post('/discount-cards', this.discount_card);
                this.goBack();
            },

            async uploadPicture(picture) {
                const formData = new FormData();
                formData.append('file', picture);
                const resp = await this.axios.post('/files/upload', formData);
                console.log(resp);
                return resp.data.filename;
            },

            goBack() {
                this.$router.push({
                    path: `/partners/${this.partner.id}/discount-cards`
                });
            },
        },
    };
</script>
